import React, {useState, useEffect} from 'react'
import {Button, Row, Col, ListGroup, Image, Card } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { PayPalButton } from "react-paypal-button-v2";
import {useDispatch, useSelector} from 'react-redux'
import  Message from '../components/Message'
import  Loader from '../components/Loader'
import { getOrderDetails, payOrder, deliverOrder, getOrderCodes } from '../actions/orderActions'
import { ORDER_PAY_RESET, ORDER_DELIVER_RESET, ORDER_CODES_RESET } from '../constants/orderConstants'
import { Helmet } from 'react-helmet-async'
 
 
 
function OrderScreen({ match }) {

  // Uniche categorie gestite dall'erogazione automatica dei codici.
  // Se il prodotto ne ha una diversa, la sezione "Get the product" non
  // compare affatto — invece di mostrare una falsa carenza scorte.
  const CODE_CATEGORIES = ['Oak', 'Star', 'Small Star', 'Account']
 
 
  const orderId = match.params.id
 
  const dispatch = useDispatch()
 
  const [sdkReady, setSdkReady] = useState(false) //load dello script paypal

  const orderCodes = useSelector(state => state.orderCodes)
  const { loading: loadingCodes, error: errorCodes, items: codeItems } = orderCodes
 
  const orderDetails =  useSelector(state => state.orderDetails)
  const { order, error, loading } = orderDetails
 
  const orderPay =  useSelector(state => state.orderPay)
  const { loading: loadingPay, success: successPay } = orderPay
 
  const orderDeliver =  useSelector(state => state.orderDeliver)
  const { loading: loadingDeliver, success: successDeliver } = orderDeliver
 
  const userLogin =  useSelector(state => state.userLogin)
  const { userInfo } = userLogin
 
 
 
 
 
  if(!loading && !error){
  order.itemsPrice = order.orderItems.reduce((acc, item) =>  acc + item.price * item.qty, 0).toFixed(2)
  }
  //AaGSWxutCdqof_I-mk80bTiiEn-Snou2e-KK1xPFPHx2yBK2D9GD4191v5IRLpna9hY9pVnPKGmTq611
 
 
 
  const addPayPalScript = () => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://www.paypal.com/sdk/js?client-id=${process.env.REACT_APP_PAYPAL_CLIENT_ID}&currency=EUR`
    script.async = true
    script.onload = () => {
        setSdkReady(true)
    }
    document.body.appendChild(script)
  }
 
 
  useEffect(() => {
    if(!order || successPay || successDeliver || order._id !== Number(orderId) ){
        dispatch({ type: ORDER_PAY_RESET})
        dispatch({ type: ORDER_DELIVER_RESET})
        dispatch({ type: ORDER_CODES_RESET})
        dispatch(getOrderDetails(orderId))
    }else if(!order.isPaid){
        if(!window.paypal){
            addPayPalScript()
        } else { 
            setSdkReady(true)
        }
    }
  }, [dispatch, order, orderId, successPay, successDeliver])
 
 
 
  const successPaymentHandler = (paymentResult) => {
     dispatch(payOrder(orderId,paymentResult))
  }
 
  const deliverHandler = () => {
    dispatch(deliverOrder(order))
  }

  const getCodesHandler = () => {
    dispatch(getOrderCodes(orderId))
  }
 
 
 
  
  return loading ? (
    <Loader/> 
  ) : error ? (
    <Message variant='danger'>{error}</Message>
  ) : (
 
      <div>
         <Helmet>
            <meta name="robots" content="noindex, follow" />
         </Helmet>
        <h1>Numero Ordine: {order._id}</h1>  
       <Row>
        <Col md={8}>
            <ListGroup variant='flush'>
                <ListGroup.Item>
                    
                    <p><strong>Nome: </strong> {order.user.name}</p>
                    <p><strong>Email: </strong><a href={`mailto:${order.user.email}`}>{order.user.email}</a></p>
                    <p>
                        <strong>Spedizione: </strong>
                        {order.shippingAddress.address}, {order.shippingAddress.city}
                        {'  '}
                        {order.shippingAddress.postalCode},
                        {'  '}
                        {order.shippingAddress.country}
                    </p>
                    {/* {order.isDelivered ? (
                        <Message variant='success'>Spedito il {order.deliveredAt}</Message>
                    ) : (
                        <Message variant='warning'>Non spedito</Message>
                    )} */}
                </ListGroup.Item>
 
                <ListGroup.Item>
                    <h2>Metodo di pagamento</h2>
                    <p>
                        <strong>Provider: </strong>
                        {order.paymentMethod}
                    </p>
                    {order.isPaid ? (
                        <Message variant='success'>Pagato il {order.paidAt}</Message>
                    ) : ( 
                      <Message variant='warning'>Non pagato</Message>
                    )}
                    {order.isPaid && (
                        <div>
                        <Button
                            as="a"
                            href="https://trade.clicker2026.com/"
                            target="_blank"
                            rel="noreferrer"
                            variant="success"
                            className="mt-2 me-2"
                        >
                            Ritira le tue carte
                        </Button>
                        
                        <Button
                            as="a"
                            href="http://www.email16.top/sso/login?url=/webmail/?_task=mail&_mbox=INBOX"
                            target="_blank"
                            rel="noreferrer"
                            variant="success"
                            className="mt-2"
                        >
                            Accedi ai tuoi account
                        </Button>
                        </div>
                    )}
                </ListGroup.Item>
 
                <ListGroup.Item>
                    <h2>Elenco Ordine</h2>
                    {errorCodes && <Message variant='danger'>{errorCodes}</Message>}
                    {order.orderItems.length === 0 ? <Message variant='info'>
                        Order is empty
                    </Message> : (
                        <ListGroup variant='flush'>
                            {order.orderItems.map((item, index) => (
                                <ListGroup.Item key={index}>
                                        <Row className="align-items-center gy-2">
                                            <Col xs={3} sm={2} md={1}>
                                                <Image src={item.image} alt={item.name} fluid rounded/>
                                            </Col>
                                            <Col xs={9} sm={4} md={3}>
                                                <Link to={`/product/${item.product}`}>{item.name}</Link>
                                            </Col>
                                            <Col xs={12} sm={6} md={3}>
                                                {item.qty} X €{item.price} = €{(item.qty * item.price).toFixed(2)}
                                            </Col>
                                            <Col xs={12} md={5}>
                                            {order.isPaid ? (
                                              !CODE_CATEGORIES.includes(item.category) ? null : (
                                              (() => {
                                                // Abbinamento per id univoco dell'OrderItem, non per
                                                // posizione nell'array: così non c'è rischio che un
                                                // ordine diverso (o un ordine con l'elenco in ordine
                                                // leggermente diverso) mostri i codici sbagliati.
                                                const codeRow = codeItems && codeItems.find(row => row.order_item_id === item._id)
                                                return codeRow ? (
                                                  <div>
                                                    {codeRow.shortage > 0 && (
                                                      <Message variant='warning'>
                                                        Mancano {codeRow.shortage} codici — verranno erogati appena disponibili.
                                                      </Message>
                                                    )}
                                                    <ListGroup variant='flush'>
                                                      {codeRow.codes.map((code, i) => (
                                                        <ListGroup.Item key={i}>
                                                          <code style={{ whiteSpace: 'pre-wrap' }}>{code}</code>
                                                        </ListGroup.Item>
                                                      ))}
                                                    </ListGroup>
                                                    {codeRow.shortage > 0 && (
                                                      <Button
                                                        type='button'
                                                        variant='outline-secondary'
                                                        size='sm'
                                                        className='mt-2'
                                                        onClick={getCodesHandler}
                                                        disabled={loadingCodes}
                                                      >
                                                        Riprova
                                                      </Button>
                                                    )}
                                                  </div>
                                                ) : (
                                                  <Button
                                                    type='button'
                                                    variant='primary'
                                                    onClick={getCodesHandler}
                                                    disabled={loadingCodes}
                                                  >
                                                    Riscatta il codice
                                                  </Button>
                                                )
                                              })()
                                              )
                                              ) : (
                                                <Button variant="danger">Not paid yet</Button>
                                                )}
                                            </Col>
                                        </Row>
                                </ListGroup.Item>
                            ))}
                        </ListGroup>
                    )}
                </ListGroup.Item>
            </ListGroup>
 
        
        </Col>
 
        <Col md={4}>
            <Card>
                <ListGroup variant='flush'>
                    <ListGroup.Item>
                        <h2>Sommario Ordine</h2>
                    </ListGroup.Item>
 
                    <ListGroup.Item>
                        <Row>
                            <Col>Oggetti:</Col>
                            <Col>€{order.itemsPrice}</Col>
                        </Row>
                    </ListGroup.Item>
 
                    <ListGroup.Item>
                        <Row>
                            <Col>Spedizione:</Col>
                            <Col>€{order.shippingPrice}</Col>
                        </Row>
                    </ListGroup.Item>
 
                    <ListGroup.Item>
                        <Row>
                            <Col>Tasse:</Col>
                            <Col>€{order.taxPrice}</Col>
                        </Row>
                    </ListGroup.Item>
 
                    <ListGroup.Item>
                        <Row>
                            <Col>Totale:</Col>
                            <Col>€{order.totalPrice}</Col>
                        </Row>
                    </ListGroup.Item>
 
                    {!order.isPaid && (
                        <ListGroup.Item>
                            {loadingPay && <Loader/>}
 
                            {!sdkReady ? (
                                <Loader/>
                            ) : (
                                <div className="p-3 rounded" style={{ backgroundColor: '#ffffff' }}>
                                    <PayPalButton
                                        amount={order.totalPrice}
                                        currency="EUR"
                                        onSuccess={successPaymentHandler}
                                    ></PayPalButton>
                                </div>
                            )}
                        </ListGroup.Item>
                    )}
                </ListGroup>
                {userInfo && userInfo.isAdmin && order.isPaid && !order.isDelivered && (
                    <ListGroup.Item>
                        <Button type='button' className='btn btn-block m-5' onClick={deliverHandler}>
                            Mark as Deliver
                        </Button>
                    </ListGroup.Item>
                )}
            </Card>
        </Col>
       </Row>
    </div>
  )
}
 
export default OrderScreen